import { Component, OnInit, OnDestroy, inject, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { Router, ActivatedRoute } from '@angular/router';
import { WebAppConfigService } from '../../core/services/webapp-config.service';
import { MetaService } from '../../core/services/meta.service';

@Component({
  selector: 'app-checkout-payment-waiting',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './checkout-payment-waiting.html',
  styleUrls: ['./checkout-payment-waiting.css']
})
export class CheckoutPaymentWaitingComponent implements OnInit, OnDestroy {
  private webAppConfig = inject(WebAppConfigService);
  private router = inject(Router);
  private route = inject(ActivatedRoute);
  private cdr = inject(ChangeDetectorRef);
  private metaService = inject(MetaService);

  logoUrl: string = '';
  eventSlug: string = '';
  timeRemaining: string = '';
  private countdownInterval: any;

  ngOnInit(): void {
    const config = this.webAppConfig.config();
    if (config) {
      this.logoUrl = config.url_logo || '';
      this.metaService.resetToDefault(
        this.webAppConfig.getSiteName() + ' - ' + config.short_description,
        config.description,
        config.url_logo,
        config.url
      );
    }

    this.eventSlug = this.route.snapshot.paramMap.get('url_slug') || '';

    const expiresAt = this.route.snapshot.queryParamMap.get('expiresAt') || '';
    if (expiresAt) {
      this.startCountdown(expiresAt);
    }
  }

  ngOnDestroy(): void {
    this.clearCountdown();
  }

  private startCountdown(expiresAt: string): void {
    this.clearCountdown();
    this.updateTimeRemaining(expiresAt);
    this.countdownInterval = setInterval(() => {
      this.updateTimeRemaining(expiresAt);
    }, 1000);
  }

  private updateTimeRemaining(expiresAt: string): void {
    const now = new Date().getTime();
    const expiry = new Date(expiresAt).getTime();
    const diff = expiry - now;

    if (diff <= 0) {
      this.timeRemaining = 'Expirado';
      this.clearCountdown();
      this.goToEvent();
      return;
    }

    const minutes = Math.floor((diff % 3600000) / 60000);
    const seconds = Math.floor((diff % 60000) / 1000);
    this.timeRemaining = `${minutes}:${seconds.toString().padStart(2, '0')}`;
    this.cdr.detectChanges();
  }

  private clearCountdown(): void {
    if (this.countdownInterval) {
      clearInterval(this.countdownInterval);
      this.countdownInterval = null;
    }
  }

  goToEvent(): void {
    if (this.eventSlug) {
      this.router.navigate(['/evento', this.eventSlug]);
    } else {
      this.router.navigate(['/']);
    }
  }
}
